import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CustomTable from "../../common/CustomTable";
import { useSelector, useDispatch } from "react-redux";
import { replaceUrlParam, buildOrderDateRange } from "../../common/utils";

import {
  fetchClientUsers,
  selectClientUsers,
  fetchMoreClientUsers,
  getFullList,
} from "./clientUsersSlice";
import Grid from "@material-ui/core/Grid";
import { fetchClients, selectClients } from "../clients/clientsSlice";
// import {fetchUserPointUserByID} from '../users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    width: "100%",
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
  root: {
    display: "flex",
    flexFlow: "column",
  },
}));

export default function ClientUsersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [userpointNames, setUserPointNames] = useState([]);
  const [userIDs, setUserIDs] = useState([]);
  const edit = props.location.pathname.includes("edit");

  const {
    clientusers,
    error,
    loading,
    clientUsersList,
    lastQuery,
    clientUsersAmount,
  } = useSelector(selectClientUsers);

  const { clients, clientsList } = useSelector(selectClients);
  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 5, value: "Pending", name: "Pending" },
    { id: 16, value: "Dispatched", name: "Dispatched" },
    { id: 9, value: "Completed", name: "Completed" },
    { id: 23, value: "Refunded", name: "Refunded" },
    { id: 24, value: "Processing", name: "Processing" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [dateBefore, setDateBefore] = useState(null);
  const [dateAfter, setDateAfter] = useState("");
  const [client, setClient] = useState("");

  const urlParams = new URLSearchParams(window.location.search);

  const invoiceParam = urlParams.get("invoice");
  // const clientParam = urlParams.get('client');

  const headCells = [
    {
      id: "id",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "User #",
      long: false,
      sortable: true
    },
    {
      id: "username",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Username",
      long: false,
      sortable: true
    },
    {
      id: "displayName",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member Name",
      long: false,
      sortable: true
    },
    {
      id: "email",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Member Email",
      long: false,
      sortable: true
    },
    {
      id: "redeemablePoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Unspent Points",
      long: false,
      sortable: true,
    },
    {
      id: "redeemedPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Spent Points",
      long: false,
      sortable: true,
    },
    {
      id: "purchasedPoints",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Purchased Points",
      long: false,
      sortable: true,
    },
    {
      id: "pendingPoint",
      checked: false,
      numeric: false,
      disablePadding: false,
      label: "Pending Points",
      long: false,
      sortable: true,
    },
    {
      id: "refundedPoints",
      checked: false,
      numeric: false,
      disablePadding: false,
      label: "Refunded Points",
      long: false,
      sortable: true,
    },
    {
      id: "totalPointsEarned",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Total Points",
      long: false,
      sortable: true,
    },
    {
      id: "loginCount",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Login Count",
      long: false,
      sortable: true,
    },
    {
      id: "lastLogin",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Login",
      long: false,
    },
    {
      id: "mobile",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Mobile No.",
      long: false,
    },
    {
      id: "phoneNumber",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Phone No.",
      long: false,
    },
    {
      id: "role",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Role",
      long: false,
    },
    {
      id: "streetAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Street Address",
      long: false,
      object: true,
      objectProperty: "streetName",
    },
    {
      id: "streetAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Suburb",
      long: false,
      object: true,
      objectProperty: "suburb",
    },
    {
      id: "streetAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Post Code",
      long: false,
      object: true,
      objectProperty: "postCode",
    },
    {
      id: "streetAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "City",
      long: false,
      object: true,
      objectProperty: "city",
    },
    {
      id: "streetAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "State",
      long: false,
      object: true,
      objectProperty: "state",
    },
    {
      id: "streetAddress",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Country",
      long: false,
      object: true,
      objectProperty: "country",
    },
    {
      id: "createdAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "User Created",
      long: false,
      sortable: true,
    },
    {
      id: "updatedAt",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Last Updated",
      long: false,
      sortable: true,
    },
  ];

  const handleClientUsersChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedUserPoint = clientUsersList.filter(
      (userpoint) => userpoint.userpointNumber === event.target.value
    );
    selectedUserPoint && idsArr.push(selectedUserPoint[0].id);
    // });

    setUserPointNames(event.target.value);
    setUserIDs(idsArr);
  };

  useEffect(() => {
    dispatch(fetchClients({ token: jwtToken, query: "" }));
  }, []);

  const handleChange = (event) => {
    setClient(event.target.value);
    let searchQuery = `?limit=${rowsPerPage}`;

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }

    if (invoiceParam) {
      searchQuery = replaceUrlParam(searchQuery, "invoiceid", rowsPerPage);
    }

    // searchQuery = replaceUrlParam(searchQuery, "clients", event.target.value);

    dispatch(
      fetchClientUsers({
        token: jwtToken,
        query: searchQuery,
        clientID: event.target.value
        // query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  };

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > clientUsersList.length
            ? rowsPerPage
            : clientUsersList.length,
        query: searchQuery,
        targetLength: clientUsersAmount,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        clientUsersList.length < clientUsersAmount &&
        clientUsersList.length < expectedLen
      ) {
        dispatch(
          fetchMoreClientUsers({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
            clientID: client
          })
        );
      } else if (clientUsersList.length == clientUsersAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
      case "redeemablePoints":
        property = "redeemable";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchClientUsers({
        token: jwtToken,
        query: searchQuery,
        clientID: client
      })
    );
  };

  const handleSearch = () => {
    const daterange = buildOrderDateRange(dateBefore, dateAfter);

    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (daterange) {
      searchQuery = replaceUrlParam(searchQuery, "odate", daterange);
    }
    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchClientUsers({
        query: searchQuery,
        token: jwtToken,
        clientID: client
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setUserPointNames([]);
    setUserIDs([]);
    setStatusNames([]);
    setStatusIDs([]);
    setDateAfter("");
    setDateBefore("");
    setSearchTerm("");
    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchClientUsers({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
        clientID: client
      })
    );
    setCurrentPage(0);
  };

  const selectNames = [];

  const [rowList, setRowList] = useState([...headCells]);

  const cellList = headCells.map((cell) => {
    return cell.id;
  });

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded" || loading === "idle") {
    content = (
      <CustomTable
        data={clientUsersList}
        actionsLists={[]}
        actionsHandleChange={[]}
        actionsNames={[]}
        headCells={headCells}
        cellList={cellList}
        // handleSearch={handleSearch}
        handleClear={handleClear}
        area={"userpoint"}
        selectNames={selectNames}
        setSearchTerm={setSearchTerm}
        setDateBefore={setDateBefore}
        setDateAfter={setDateAfter}
        dateAfter={dateAfter}
        dateBefore={dateBefore}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={clientUsersAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      <Grid
        item
        sm
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 32,
          paddingRight: 32,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              marginRight: 24,
              padding: 0,
              marginLleft: 12,
              fontSize: 24,
              fontWeight: "bold",
              color: "#42494E",
              marginBottom: 0,
              marginTop: 4,
            }}
          >
            Select Client:
          </div>

          <div>
            <FormControl
              style={{ width: 250 }}
              margin="dense"
              className={classes.formControl}
            >
              <Select
                variant="outlined"
                value={client}
                margin="dense"
                onChange={handleChange}
                inputProps={{
                  name: "client",
                  id: "client-simple",
                }}
              >
                {clientsList.map((client) => (
                  <option key={client.id} value={client.id}>
                    {client.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </Grid>

      {content}
    </Grid>
  );
}
